import React, { Component } from 'react';
import PropTypes from 'prop-types';
import copy from 'clipboard-copy';
import { Redirect } from 'react-router';
import { Button, Container, Image } from 'react-bootstrap';
import fav from '../images/blackHeartIcon.svg';
import notFav from '../images/whiteHeartIcon.svg';
import share from '../images/shareIcon.svg';
import { addFoodToFavorite, continueRecipe, fetchDrinkApiById, fetchFoodRecomendation,
  getIngredientList, isFavoriteRecipe, recipeIsDone } from '../helpers';
import RecomendationCard from './RecomendationCard';
import './generico.css';
import IngredientList from './IngredientList';

class GenericoBebidas extends Component {
  constructor() {
    super();
    this.state = {
      redirectTo: '',
      currentRecipe: {},
      ingredientList: {},
      recomendations: [],
      isThisRecipeDone: false,
      continueThisRecipe: false,
      favoriteRecipe: false,
    };
    this.redirectToPage = this.redirectToPage.bind(this);
    this.fetchApi = this.fetchApi.bind(this);
    this.favoriteThisItem = this.favoriteThisItem.bind(this);
  }

  componentDidMount() {
    this.fetchApi();
  }

  fetchApi() {
    const { match: { params: { id } } } = this.props;
    this.fetchDrinkRecipe(id);
  }

  async fetchDrinkRecipe(drinkId) {
    const recipe = await fetchDrinkApiById(drinkId);
    const ingredients = getIngredientList(recipe);
    const recomendation = await fetchFoodRecomendation();
    const finishedRechipe = recipeIsDone(drinkId);
    const alreadyStartedThisRecipe = continueRecipe(drinkId, 'bebidas');
    const isFavorite = isFavoriteRecipe(drinkId);
    this.setState({
      ingredientList: ingredients,
      recomendations: recomendation,
      currentRecipe: recipe,
      isThisRecipeDone: finishedRechipe,
      continueThisRecipe: alreadyStartedThisRecipe,
      favoriteRecipe: isFavorite,
    });
  }

  share() {
    copy(window.location);
    const SHOW_TIME = 3000;
    this.setState({ displayShareMesage: true }, () => {
      setTimeout(() => this.setState({ displayShareMesage: false }), SHOW_TIME);
    });
  }

  redirectToPage(page) {
    this.setState({ redirectTo: page });
  }

  favoriteThisItem() {
    const { currentRecipe } = this.state;
    const done = addFoodToFavorite(currentRecipe, 'bebida');
    this.setState({ favoriteRecipe: done });
  }

  render() {
    const { currentRecipe, isThisRecipeDone,
      ingredientList, recomendations, displayShareMesage,
      continueThisRecipe, redirectTo, favoriteRecipe } = this.state;
    const { match: { params: { id } } } = this.props;

    if (redirectTo) {
      return <Redirect push to={ redirectTo } />;
    }

    return (
      <div className="recipe-detail-wrapper">
        <Container>
          <div className="recipe-detail-header">
            <div className="recipe-detail-photo-wrapper">
              <Image
                src={ currentRecipe.strDrinkThumb }
                alt={ `Foto de ${currentRecipe.strDrink}` }
                data-testid="recipe-photo"
                className="linkImage recipe-detail-photo"
              />
            </div>
            
            <div className="recipe-detail-meta">
              <span className="recipe-detail-badge" data-testid="recipe-category">
                {currentRecipe.strAlcoholic}
              </span>
              <h1 className="recipe-detail-title" data-testid="recipe-title">
                {currentRecipe.strDrink}
              </h1>

              <div className="recipe-detail-actions">
                <button
                  className="recipe-button"
                  type="button"
                  aria-label="Compartilhar receita de bebida"
                  onClick={ () => this.share() }
                >
                  <img
                    src={ share }
                    alt="Compartilhar"
                    data-testid="share-btn"
                  />
                </button>
                <button
                  className="recipe-button"
                  type="button"
                  aria-label={favoriteRecipe ? 'Remover dos favoritos' : 'Favoritar bebida'}
                  onClick={ this.favoriteThisItem }
                >
                  <img
                    src={ favoriteRecipe ? fav : notFav }
                    alt="Favoritar"
                    data-testid="favorite-btn"
                  />
                </button>
              </div>

              {displayShareMesage && (
                <div className="share-toast" role="status" aria-live="polite">
                  ✨ Link copiado para a área de transferência!
                </div>
              )}
            </div>
          </div>

          <div className="recipe-detail-section">
            <h4>Ingredientes</h4>
            {ingredientList && <IngredientList ingredientList={ ingredientList } />}
          </div>

          <div className="recipe-detail-section">
            <h4>Modo de Preparo</h4>
            <div className="recipe-instructions-box" data-testid="instructions">
              {currentRecipe.strInstructions}
            </div>
          </div>

          {recomendations && recomendations.length > 0 && (
            <div className="recipe-detail-section">
              <h4>Comidas Recomendadas para Acompanhar</h4>
              <RecomendationCard
                recomendations={ recomendations }
                redirectToPage={ this.redirectToPage }
              />
            </div>
          )}

          {!isThisRecipeDone && (
            <div className="recipe-start-sticky">
              <Button
                block
                className="default-button green start-recipe-btn-custom"
                type="button"
                data-testid="start-recipe-btn"
                onClick={ () => {
                  this.redirectToPage(`/bebidas/${id}/in-progress`);
                } }
              >
                <span>{continueThisRecipe ? 'Continuar Receita &rarr;' : 'Iniciar Receita &rarr;'}</span>
              </Button>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

GenericoBebidas.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default GenericoBebidas;
